"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ID_SCORECARD_DEFINITION = exports.PAYMENT_SCHEDULE_CHECKER_DEFINITION = void 0;
exports.getToolRegistryEntry = getToolRegistryEntry;
exports.listToolRegistryEntries = listToolRegistryEntries;
exports.listRegisteredToolKeys = listRegisteredToolKeys;
const checker_js_1 = require("./checker.js");
const enums_js_1 = require("./enums.js");
const payment_visualiser_js_1 = require("./payment-visualiser.js");
const scorecard_js_1 = require("./scorecard.js");
const CHECKER_EVENTS = [
    { type: "page_view" },
    { type: "tool_viewed" },
    { type: "tool_started" },
    { type: "schedule_submitted" },
    { type: "preview_shown" },
    { type: "gate_viewed" },
    { type: "gate_submitted" },
    { type: "result_viewed" },
    { type: "cta_clicked" },
    { type: "see_how_protected_tapped" },
    { type: "check_another_tapped" },
    { type: "invite_sheet_opened" },
    { type: "invite_option_picked" },
    { type: "invite_submitted" },
    { type: "faq_opened" },
];
const SCORECARD_EVENTS = [
    { type: "page_view" },
    { type: "tool_viewed" },
    { type: "tool_started" },
    { type: "id_added" },
    { type: "answer_given" },
    { type: "note_added" },
    { type: "preview_shown" },
    { type: "gate_viewed" },
    { type: "gate_submitted" },
    { type: "result_viewed" },
    { type: "report_viewed" },
    { type: "comparison_viewed" },
    { type: "cta_clicked" },
    { type: "message_copied" },
    { type: "question_copied" },
    { type: "see_how_protected_tapped" },
    { type: "invite_sheet_opened" },
    { type: "invite_option_picked" },
    { type: "invite_submitted" },
    { type: "faq_opened" },
    { type: "how_scored_opened" },
];
/** TRD §11.1 / HAN-668: match for early stages; invite from comparing_quotes onward. */
function stageCtaRules() {
    return enums_js_1.LEAD_STAGES.map((stage) => ({
        stage,
        variant: stage === "getting_keys" || stage === "meeting_ids" ? "match" : "invite",
    }));
}
/** Match / invite by lead stage (gate picks CTA; engine does not). */
exports.PAYMENT_SCHEDULE_CHECKER_DEFINITION = {
    key: "payment_schedule_checker",
    version: 1,
    gate: {
        placement: "after_preview",
        fields: ["stage", "name", "whatsapp", "marketingOptIn"],
        consentPurposes: ["service", "marketing_updates"],
    },
    limits: { maxRunsPerPhoneLifetime: 20, maxRunsPerPhonePerDay: 5 },
    fulfilment: {
        screen: true,
        pdfTemplate: "lead-magnet/payment_schedule_checker",
        firstMessageTemplate: "payment_schedule_checker_first_touch",
    },
    ctaRules: stageCtaRules(),
    events: CHECKER_EVENTS,
};
/** ID Scorecard. Gate after preview; CTA by stage (same match/invite split as Checker). */
exports.ID_SCORECARD_DEFINITION = {
    key: "id_scorecard",
    version: 1,
    gate: {
        placement: "after_preview",
        fields: ["stage", "name", "whatsapp", "marketingOptIn"],
        consentPurposes: ["service", "marketing_updates"],
    },
    limits: { maxRunsPerPhoneLifetime: 20, maxRunsPerPhonePerDay: 5 },
    fulfilment: {
        screen: true,
        pdfTemplate: "lead-magnet/id_scorecard",
        firstMessageTemplate: "id_scorecard_first_touch",
    },
    ctaRules: stageCtaRules(),
    events: SCORECARD_EVENTS,
};
function stubDefinition(key) {
    return {
        key,
        version: 1,
        gate: { placement: "none", fields: [], consentPurposes: [] },
        fulfilment: { screen: false, manual: true },
        ctaRules: [],
        events: [{ type: "page_view" }],
    };
}
const entries = new Map();
function register(entry) {
    entries.set(entry.definition.key, entry);
}
register({
    definition: exports.PAYMENT_SCHEDULE_CHECKER_DEFINITION,
    handler: checker_js_1.checkerHandler,
});
register({
    definition: exports.ID_SCORECARD_DEFINITION,
    handler: scorecard_js_1.scorecardHandler,
});
register({ definition: payment_visualiser_js_1.PAYMENT_VISUALISER_DEFINITION });
register({ definition: stubDefinition("id_matching") });
register({ definition: stubDefinition("id_due_diligence") });
function getToolRegistryEntry(key) {
    return entries.get(key);
}
function listToolRegistryEntries() {
    return [...entries.values()];
}
function listRegisteredToolKeys() {
    return [...entries.keys()];
}
